module.exports = __webpack_public_path__ + "img/medtronic_bis.9d2ef068.png";